import { useQuery } from '@tanstack/react-query'
import { getKYC } from '~/services/user'
import { useBoundVerificationUserStore } from '../../stores'

const useUserKYC = () => {
  const { setPersonalData } = useBoundVerificationUserStore(
    (state) => ({
      setPersonalData: state.setPersonalData,
    }),
  )
  return useQuery({
    queryKey: ['user-kyc'],
    queryFn: async () => {
      try {
        const response = await getKYC()
        const result = response?.data?.data
        setPersonalData(result)
        return result
      } catch (error) {
        throw error
      }
    },
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export { useUserKYC }
